"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricMapEventListener = void 0;
const react_1 = __importDefault(require("react"));
const Context_1 = require("./Context");
/**
 * **This component must be included inside a FabricMap or FabricMapHost**.
 *
 * This component allows attaching listener functions to Map events.
 */
exports.FabricMapEventListener = (0, Context_1.withMap)(({ map, event, listener, once = false }) => {
    react_1.default.useEffect(() => {
        if (once) {
            map.once(event, listener);
        }
        else {
            map.on(event, listener);
        }
        return () => {
            map.off(event, listener);
        };
    }, [event, listener, map, once]);
    return null;
});
